import { Tenant } from '../../models/resource-manager';
import { createStringIdAdapter } from './common/string-id-adapter';

export const tenantAdapter = createStringIdAdapter<Tenant>();
